const debounce = require("lodash.debounce");
import { dataLayerConfig } from "../../features/dataLayer";
export const debouncedPush = debounce((push, action, label)=>push(action, label), 1500);
export const pushCollectionAction = ()=>{
    const pushDataLayer = dataLayerConfig();
    return (action, label)=>pushDataLayer({
            category: 'collection',
            action,
            label
        });
};
export const titleAndAuthor = (item)=>{
    const { title, mainTitle, authors } = item;
    const titleText = mainTitle || title;
    return authors.length > 0 ? `${titleText} - ${authors[0]}` : titleText;
};
